import React, { useState } from "react"

import { useUsers, userTypes } from "../../../../hooks/api/useUsers"

export function useWorker({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const { list, filterOperatorTypes } = useUsers({ userType: userTypes.worker });

    // list workers
    const listWorkers = async ({
        props,
        dataTypes: _dataTypes = ["location"]
    }) => {

        props.dataTypes = _dataTypes

        let filterValues = [
        ]

        // if (_containerIds.length > 0) {
        //     filterValues = [...filterValues, ...[
        //         {
        //             name: `id`,
        //             operator: filterOperatorTypes.anyOf,
        //             value: JSON.stringify(_containerIds),
        //         },
        //     ]]
        // }

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        const result = await list(props)

        let data = result?.data?.workers ? result.data.workers : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    return {
        filterOperatorTypes,
        listWorkers,
    }
}